import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import generate from '../../services/meeting/authMeeting';
import { JaaSMeeting } from '@jitsi/react-sdk';
import { JITSI_APP_ID } from '../../constants/constants';

interface Props {
  roomOrganizerName: string;
  sessionId: string;
  handleClose: () => void;
  hidePreMeetingOptions: () => void;
  sessionTopic: string;
}

export default function CoachingJitsiMeetingRoom({
  roomOrganizerName,
  sessionId,
  handleClose,
  hidePreMeetingOptions,
  sessionTopic
}: Props) {
  const { user } = useAuth0();
  const { sub, name, email } = user;
  const sessionIdPartial = sessionId?.slice(0, 6);
  const roomName = `${roomOrganizerName} ${sessionIdPartial}`;

  const [jwt, setJwt] = useState<string | null>(null);

  useEffect(() => {
    generate({ id: sub, name, email }).then(setJwt);
  }, [sub, name, email]);

  if (!jwt) {
    return null;
  }

  return (
    <div style={{ height: '100%' }}>
      <JaaSMeeting
        appId={JITSI_APP_ID}
        roomName={roomName}
        jwt={jwt}
        getIFrameRef={(iframe) => {
          iframe.style.height = '100%';
        }}
        userInfo={{
          displayName: name,
          email: email
        }}
        configOverwrite={
          {
          }
        }
        interfaceConfigOverwrite={
          {
          }
        }
        onApiReady={() => {
          console.log('User Joined ', user.name);
          hidePreMeetingOptions();
        }}
        onReadyToClose={() => handleClose()}
      />
    </div>
  );
}
